__turbopack_context__.v({
  "container": "tSFsOW_container",
  "size--sm": "tSFsOW_size--sm",
});
